<div class="input-group">
    <input
        class="form-control datetime-input"
        type="datetime-local"
        [formControl]="dateTimeInputControl"
        paceCoreValidationMessage
        [validation]="dateTimeInputControl"
        [attr.aria-label]="ariaLabel"
    />
    <span class="input-group-text"><fa-icon [icon]="faCalendar"></fa-icon></span>
</div>
